import React from 'react'
import Head from 'next/head'
import { urlFor } from '../../client'
import { siteUrl } from '../../lib/companyInfo'
import { buildSeoMetadata } from '../../lib/seo-metadata.mjs'
import {
  selongBelanakDestination,
  buildBreadcrumb,
  SECTION_LABELS,
} from '../../lib/structuredData'

const SITE_NAME = 'Selong Belanak'
const DEFAULT_SHARE_IMAGE = `${siteUrl}/og-default.png`

const SEO = ({ seo, router, header, type = 'website', destination = true, breadcrumb: breadcrumbOverride, jsonLd = [] }) => {
  const { path, canonicalUrl, pageTitle, description: metaDesc, shareTitle, shareDescription, noIndex } =
    buildSeoMetadata({ seo, asPath: router.asPath, siteUrl, preview: router.isPreview, type })
  const shareSource = seo?.shareGraphic?.asset ? seo.shareGraphic : header?.photo
  const shareImage = shareSource?.asset
    ? urlFor(shareSource).width(1200).height(630).fit('crop').auto('format').url()
    : DEFAULT_SHARE_IMAGE

  const sectionLabel = SECTION_LABELS[path]
  const breadcrumb = breadcrumbOverride || (sectionLabel ? buildBreadcrumb(sectionLabel, path) : null)

  return (
    <Head>
      {/* Title */}
      <title>{pageTitle}</title>
      {/* Meta Description (always emitted) */}
      <meta name="description" content={metaDesc} />
      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" sizes="16x16 32x32 48x48" key="favicon-ico" />
      <link rel="icon" href="/favicon.svg" type="image/svg+xml" sizes="any" key="favicon-svg" />
      <link rel="apple-touch-icon" href="/apple-touch-icon-180x180.png" sizes="180x180" />
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      {/* Conditional Meta Robots */}
      {noIndex && (
        <meta name="robots" content="noindex, follow" />
      )}
      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={shareTitle} />
      <meta property="og:description" content={shareDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={shareImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={shareTitle} />
      <meta name="twitter:description" content={shareDescription} />
      <meta name="twitter:image" content={shareImage} />
      {/* Structured data */}
      {jsonLd.map((data, index) => <script key={`page-schema-${index}`} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />)}
      {destination && <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(selongBelanakDestination),
        }}
      />}
      {breadcrumb && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumb) }}
        />
      )}
    </Head>
  )
}

export default SEO
